import React, { Component } from "react";
import PageHomesItem from './PageHomesItem';

export default class PageHomes extends Component {
		  	
	render () {
		
		let block = this.props.block;
		
		console.log('block');
		console.log(block);
										
	    return (
		    
			<>
		     	{block.homes &&
			     	<>
						{block.homes.map((home,i) =>
							{
								return (
									<PageHomesItem index={i} key={i} block={home}></PageHomesItem>
								)
							}
						)}
					</>
				}
				
		    </>
		)
	}
}
